import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {ReferentielFournisseurPOTListPage} from './ReferentielFournisseurPOTListPage'
import ReferentielFournisseurPOTAddPage from './ReferentielFournisseurPOTAddPage'
import ReferentielFournisseurPOTEditPage from './ReferentielFournisseurPOTEditPage'

const ReferentielFournisseurPOTWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Fournisseurs POT</PageTitle>
              <ReferentielFournisseurPOTListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Fournisseurs POT', path: '/referentiel-fournisseur-pot', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <ReferentielFournisseurPOTAddPage />
            </>
          }
        />
        <Route
          path='/:fournisseurId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Fournisseurs POT', path: '/referentiel-fournisseur-pot', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <ReferentielFournisseurPOTEditPage />
            </>
          }
        />

        <Route index element={<Navigate to='/referentiel-fournisseur-pot/liste' />} />
      </Routes>
    </>
  )
}

export {ReferentielFournisseurPOTWrapper}
